






































































/** @format */

import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { contributionQueryList, contributionExport } from '@/api/financial-management/index';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { IAntColumn } from '@root/types/table';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
import { tollManMap } from '@/types/financial-management/dictionaries';
import * as _ from 'lodash';
@Component({
  name: 'MonthlyContributionStatement',
  components: {
    ParkingLotSearch
  }
})
export default class MonthlyContributionStatement extends Mixins(TableMixin, TableWidthMixin) {
  // private pageSize = 10;
  // private total = 0;
  totalPage = 1;
  // private current = 1;
  private tableLoading = false;
  private moment = moment;
  private tableData = [];
  defaultTime = [];
  private tollManList = _.filter(Utils.toLabelVal(tollManMap), function(o) {
    return o.value != '01';
  });
  filterParam: any = {
    startReportDate: '',
    endReportDate: '',
    parkIds: [],
    cardType: ''
  };
  created() {
    this.fetchTableData(true);
    console.log(this.$store.state.dictionaries.allDictionaries.chk_type, '..................>');
  }
  onSearch() {
    this.fetchTableData(true);
  }
  /**
   * 当分页组件变化
   */
  // private showSizeChangerChange(current: any, pageSize: any) {
  //   this.current = current
  //   this.pageSize = pageSize
  //   this.fetchTableData(false)
  // }
  /**
   * 获取数据
   */
  async fetchTableData(resetPage: boolean) {
    if (resetPage) this.current = 1;
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { parkIds, startReportDate, endReportDate, cardType } = this.filterParam;
      const { msg, data = {} } = await contributionQueryList({
        parkIds: parkIds ? parkIds.join(',') : '',
        cardType,
        startReportDate,
        endReportDate,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const {
        datas,
        totalNum,
        totalPage,
        totalAmounts,
        tradeNums,
        totalReceivables,
        outstandingAmounts,
        electronicReceivedAmounts,
        electronicChargeCounts,
        discountMoneys
      } = data;
      this.tableData = datas;
      this.total = Number(data.totalNum);
      this.totalPage = Number(totalPage);
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * @param { 点击导出 }
   */
  private async download() {
    try {
      const { parkIds, startReportDate, endReportDate, cardType } = this.filterParam;
      await contributionExport(
        {
          parkIds: parkIds ? parkIds.join(',') : '',
          cardType,
          startReportDate,
          endReportDate
        },
        '预收月度分摊表'
      );
    } catch (e) {
      console.log('exportOrderEnter', '导出失败');
    }
  }

  cardTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.chk_type).splice(1);
  cordTypeListMap = this.$store.state.dictionaries.allDictionaries.chk_type;

  get tableColums(): IAntColumn[] {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '业务类型',
        dataIndex: 'cardType',
        width: 200,
        scopedSlots: { customRender: 'cardType' }
      },
      {
        title: '时间',
        dataIndex: 'reportDate',
        width: 200
      },
      {
        title: '预收分摊金额',
        dataIndex: 'sharePrice',
        width: 200,
        scopedSlots: { customRender: 'refundPrice' }
      },

      {
        title: '退费金额',
        dataIndex: 'refundPrice',
        scopedSlots: { customRender: 'refundPrice' }
      }
    ];
  }
  /**
   * 时间变化
   * @param date
   * @param dateString
   */
  onTimeChange(date: any, dateString: string[]) {
    let [startReportDate, endReportDate] = dateString;
    this.filterParam.startReportDate = startReportDate;
    this.filterParam.endReportDate = endReportDate;
  }
  /**
   * @param {type} property - 点击清除按钮.
   */
  onClear({ defaultParkList }) {
    this.filterParam = {
      startReportDate: '',
      endReportDate: '',
      parkIds: defaultParkList,
      cardType: ''
    };
    this.defaultTime = [];
    this.onSearch();
    console.log('重置1111');
  }
}
